var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3221","data-name":"Path 3221","d":"M-311.609,385.78l-5,5-5-5","transform":"translate(322.14 -385.25)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1.5","opacity":"0.9"}));
}

Dropdown.defaultProps = {"width":"11.061","height":"6.591","viewBox":"0 0 11.061 6.591"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
